import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const LOCALES_WITH_WARRANTY_EXCLUSION = ['fr-fr', 'fr-be']

type Link = {
  name: string
  params: Record<string, string>
}

export const LEGAL_PAGE_NAME = {
  DATA_PROTECTION: 'data-protection',
  BUYBACK: 'terms-of-trade-in',
  TERMS_SALE: 'terms-of-sale',
  TERMS_USE: 'terms-of-use',
  TERMS_SERVICE: 'terms-of-service',
  WARRANTY: 'warranty',
  LEGAL_MENTIONS: 'legal-mentions',
}

export const CMS = {
  LEGAL_PAGE: 'legal',
} as const

export const TERMS: Partial<Record<MarketCountryCode, Link>> = {
  [MarketCountryCode.FR]: {
    name: CMS.LEGAL_PAGE,
    params: {
      pageName: LEGAL_PAGE_NAME.TERMS_SALE,
    },
  },
  [MarketCountryCode.BE]: {
    name: CMS.LEGAL_PAGE,
    params: {
      pageName: LEGAL_PAGE_NAME.TERMS_SALE,
    },
  },
  [MarketCountryCode.PT]: {
    name: CMS.LEGAL_PAGE,
    params: {
      pageName: LEGAL_PAGE_NAME.TERMS_SALE,
    },
  },
  [MarketCountryCode.US]: {
    name: CMS.LEGAL_PAGE,
    params: {
      pageName: LEGAL_PAGE_NAME.TERMS_SERVICE,
    },
  },
}
